import React from 'react';
import { Form, Header, Message, Segment } from 'semantic-ui-react';
import axios from 'axios';

import EnrolledStudents from './EnrolledStudents';
import EnrolledWithAverageGrade from './EnrolledWithAverageGrade';
import StudyProgramPerCycle from './StudyProgramPerCycle';
import EnrolledStudentsPerCountries from './EnrolledStudentsPerCountries';
import EnrolledStudentsPerMunicipalities from './EnrolledStudentsPerMunicipalities';
import ConstReports from '../Reports/ConstReports/ConstReports';
import EnrolledStudentsPerGender from './EnrolledStudentsPerGender';
import EnrolledStudentWithNumberOfPassedCourses from './EnrolledStudentWithNumberOfPassedCourses';
import EnrolledStudentAverageGradeAndPassedCourses from './EnrolledStudentAverageGradeAndPassedCourses';
import PreviousSemesterStudents from './PreviousSemesterStudents';
import WithdrawalStudents from './WithdrawalStudents';
import GradStudents from './GradStudents';
import LockedGraduatedStudents from './LockedGraduatedStudents';
import WorkloadReport from '../../HR/WorkloadReport';
import EmployeesByType from '../../HR/EmployeesByType';
import EmployeesByAcademicTytle from '../../HR/EmployeesByAcademicTytle';
import EmployeesByTypeAndGender from '../../HR/EmployeesByTypeAndGender';
import EmployeesByTypeAndPosition from '../../HR/EmployeesByTypeAndPosition';
import EmployeesByTypePositionAndAverageYear from '../../HR/EmployeesByTypePositionAndAverageYear';
import AssociateEmployeesByTypeAndPosition from '../../HR/AssociateEmployeesByTypeAndPosition';
import { fetchAcademicYears, fetchEmployeeTypes, fetchFaculties } from '../../Lookups/util';
import EnrolledStudentsPerCountriesAllData from './EnrolledStudentsPerCountriesAllData';
import EnrolledStudentsPerGenderAllData from './EnrolledStudentsPerGenderAllData';
import EnrolledStudentsPerMunicipalitiesAllData from './EnrolledStudentPerMunicipalitiesAllData';
import StudentsWithDisciplinaryProcedure from './StudentsWithDisciplinaryProcedure';
import StudentsWithPause from './StudentsWithPause';
import EnrolledStudentsWithCourses from './EnrolledStudentsWithCourses';
import CoursesByCycle from './CoursesPerCycle';
import CourseListPerCycle from './CourseListPerCycle';
import StudentsByCycle from './StudentsPerCycle';
import StudentAccreditationReport from './StudentAccreditationReport';
import EmployeesByStudyProgramBasic from './EmployeesByStudyProgramBasic';
import EmployeesGenderAndAgeByPosition from '../../HR/EmployeesGenderAndAgeByPosition';
import EmployeesGenderAndAgeByEducationLevel from '../../HR/EmployeesGenderAndAgeByEducationLevel';
import EmployeesByTypeAndAcademicYear from '../../HR/EmployeesByTypeAndAcademicYear';
import EnrolledStudentsPerCourses from './EnrolledStudentsPerCourses';
import EnrolledStudentsPerStudyYearAndStudyTypeForFaculty from './EnrolledStudentsPerStudyYearAndStudyTypeForFaculty';
import GradStudentsPerStudyYearAndStudyTypeForFaculty from './GradStudentsPerStudyYearAndStudyTypeForFaculty';
import StudyProgramsByStudyCyclesForFaculty from './StudyProgramsByStudyCyclesForFaculty';
import ConstReportsByAcademicYear from '../Reports/ConstReports/ConstReportsByAcademicYear';
import EnrolledAndPassedStudentsPerCourse from './EnrolledAndPassedStudentsPerCourse';
import EnrolledAndPassedStudentsPerCourseByAcademicYear from './EnrolledAndPassedStudentsPerCourseByAcademicYear';
import StudentsWithNotPassedCourses from './StudentsWithNotPassedCourses';
import StudentsMobilityReport from './StudentsMobilityReport';
import StudentsEligibleForNextStudyYear from './StudentsEligibleForNextStudyYear';
import AnalyticalReport from './AnalyticalReport';
import CourseStudentsByAcademicYear from './CourseStudentsByAcademicYear';
import {
    isFacultyScopedStudentReportRole,
    isStudentServiceRole,
    isViceDeanForEducationRole
} from './reportUiHelpers';
import './StudentsReports.css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const legacyReportIds = {
    0: 'enrolled-students',
    1: 'enrolled-students-average-grade',
    2: 'enrolled-students-countries-count',
    3: 'enrolled-students-municipalities-count',
    4: 'enrolled-students-gender-count',
    5: 'enrolled-students-passed-courses',
    6: 'enrolled-students-average-grade-passed-courses',
    7: 'withdrawal-students',
    8: 'grad-students',
    9: 'locked-graduated-students',
    10: 'course-pass-rate-semester',
    11: 'study-programs-per-cycle',
    12: 'teacher-workload',
    13: 'ou-workload',
    14: 'employees-by-type',
    15: 'employees-by-academic-title',
    16: 'employees-by-type-gender',
    17: 'employees-by-type-position',
    18: 'employees-average-age-position',
    19: 'associate-employees-position',
    20: 'employees-ou-engagements',
    21: 'employees-ou-positions',
    22: 'previous-semester-students',
    23: 'enrolled-students-countries-list',
    24: 'enrolled-students-gender-list',
    25: 'enrolled-students-municipalities-list',
    26: 'students-disciplinary-procedure',
    27: 'students-pause',
    28: 'enrolled-students-courses',
    29: 'courses-per-cycle',
    30: 'students-per-cycle',
    31: 'employees-study-program-basic',
    32: 'employees-gender-age-position',
    33: 'employees-gender-age-education-level',
    34: 'employees-type-academic-year',
    35: 'enrolled-students-per-course',
    36: 'enrolled-students-study-year-study-type',
    37: 'grad-students-study-year-study-type',
    38: 'active-study-programs-cycle',
    39: 'course-pass-rate-year',
    40: 'passed-course-students-semester',
    41: 'passed-course-students-academic-year',
    42: 'students-not-passed-courses',
    43: 'students-mobility'
};

const normalizeReportId = report => legacyReportIds[report] || report;

const getStoredReport = () => {
    const report = localStorage.getItem('report');

    return report ? normalizeReportId(report) : null;
};

const enrolledStudentsComment = [
    'Izvještaj prikazuje upisane studente uključujući apsolvente i apsolvente ponovce za odabrane obavezne parametre.',
    'Ako odaberete godinu studija ili semestar studija, apsolventi se automatski isključuju iz rezultata.',
    'Apsolvente ponovce možete isključiti dodatnim filterom bez obzira na to jesu li odabrani godina ili semestar studija.',
    'Kada godina i semestar studija nisu odabrani, apsolvente možete zasebno isključiti dodatnim filterom.',
    'Prikazani su svi upisani studenti, iako su se oni u međuvremenu ispisali sa fakulteta.',
    'Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.'
].join(' ');

const enrolledStudentsGroupComment = 'Izvještaj prikazuje upisane studente uključujući apsolvente i apsolvente ponovce za odabrane obavezne parametre. Prikazani su svi upisani studenti, iako su se oni u međuvremenu ispisali sa fakulteta. Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.';

const enrolledStudentsCountComment = 'Izvještaj prikazuje broj upisanih studenata uključujući apsolvente i apsolvente ponovce za odabrane obavezne parametre. Uključeni su svi upisani studenti, iako su se oni u međuvremenu ispisali sa fakulteta. Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.';

const courseStudentsComment = `${enrolledStudentsGroupComment}`;

const coursePassComment = '';

const gradStudentsListComment = 'Izvještaj prikazuje studente koji u odabranoj akademskoj godini imaju evidentiran apsolventski staž. Prikazani su i studenti koji su se u međuvremenu ispisali sa fakulteta. Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.';

const gradStudentsCountComment = 'Izvještaj prikazuje broj studenata koji za odabranu akademsku godinu imaju evidentiran apsolventski staž. Uključeni su i studenti koji su se u međuvremenu ispisali sa fakulteta. Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.';

const facultyScopedCycleReportComments = {
    'course-list-per-cycle': 'Izvještaj prikazuje spisak predmeta za odabrani ciklus studija prema istim uslovima kao izvještaj Broj predmeta po ciklusu: aktivni nastavni planovi, nearhivirani predmeti i evidentirana šifra i ECTS na planu. Odabir ciklusa je obavezan. Svaki predmet prikazan je jednom, bez obzira na broj planova na kojima se izvodi. Uz naziv se prikazuje komentar predmeta. Filter Studijski program obuhvata njegove aktivne planove. Bez odabranog studijskog programa prikazuju se predmeti čitave organizacione jedinice.',
    'study-programs-per-cycle': 'Izvještaj broji aktivne i arhivirane osnovne studijske programe po ciklusu. Ukoliko ne odaberete nijedan filter, prikazat će se ukupno za čitavu organizacionu jedinicu.',
    'students-per-cycle': 'Izvještaj prikazuje broj studenata po ciklusu studija. Bez odabrane akademske godine broje se studenti koji imaju barem jedan evidentiran upis u semestar ili apsolventski staž, a nisu diplomirali niti su ispisani sa tog studijskog programa. Svaka osoba broji se samo jednom unutar ciklusa, bez obzira na godinu upisa i broj studijskih programa. Za odabranu akademsku godinu brojanje odgovara izvještaju Upisani studenti za zimski semestar te godine, bez dodatnih filtera za isključivanje studenata: uključuju se upisani studenti, apsolventi i apsolventi ponovci, uključujući one koji su naknadno diplomirali ili se ispisali. U ovom prikazu svaki upis na studijski program broji se jednom, kao zaseban red u izvještaju Upisani studenti.',
    'courses-per-cycle': 'Izvještaj broji predmete po ciklusu na aktivnim studijskim programima. Arhivirani predmeti nisu uključeni. Ukoliko ne odaberete nijedan filter, prikazat će se ukupno za čitavu organizacionu jedinicu.'
};

const reportComments = {
    'course-list-per-cycle': 'Izvještaj prikazuje spisak predmeta za odabrani ciklus studija prema istim uslovima kao izvještaj Broj predmeta po ciklusu: aktivni nastavni planovi, nearhivirani predmeti i evidentirana šifra i ECTS na planu. Odabir ciklusa je obavezan. Svaki predmet prikazan je jednom, bez obzira na broj planova na kojima se izvodi. Uz naziv se prikazuje komentar predmeta. Filter Studijski program obuhvata njegove aktivne planove. Bez odabrane organizacione jedinice prikazuju se podaci svih organizacionih jedinica.',
    'enrolled-students': enrolledStudentsComment,
    'enrolled-students-average-grade': `${enrolledStudentsGroupComment}`,
    'enrolled-students-per-course': courseStudentsComment,
    'enrolled-students-countries-count': `${enrolledStudentsCountComment}`,
    'enrolled-students-countries-list': `${enrolledStudentsGroupComment}`,
    'enrolled-students-municipalities-count': `${enrolledStudentsCountComment}`,
    'enrolled-students-municipalities-list': `${enrolledStudentsGroupComment}`,
    'enrolled-students-gender-count': `${enrolledStudentsCountComment}`,
    'enrolled-students-gender-list': `${enrolledStudentsGroupComment}`,
    'enrolled-students-study-year-study-type': `${enrolledStudentsCountComment}`,
    'previous-semester-students': 'Izvještaj prikazuje studente koji su bili upisani u prethodni semestar, a nisu upisani u odabrani semestar. Apsolventi se ne prikazuju.',
    'students-eligible-next-study-year': 'Izvještaj prikazuje broj aktivnih studenata i broj studenata koji ispunjavaju uslov za prelazak u narednu godinu studija. Rezultati su grupisani po ciklusu, studijskom programu i trenutnoj godini studija. Za završnu godinu posebno su prikazani studenti koji su završili sve obaveze i mogu diplomirati te ostali studenti koji su potencijalni apsolventi ili apsolventi ponovci.',
    'withdrawal-students': 'Izvještaj prikazuje ispisane studente. Ako je izabrana akademska godina, prikazuju se samo ispisi iz te godine; bez akademske godine prikazuju se svi ispisani studenti.',
    'grad-students': gradStudentsListComment,
    'grad-students-study-year-study-type': '',
    'locked-graduated-students': 'Izvještaj prikazuje diplomirane studente kroz zapise dokumenata o završetku studija.',
    'graduated-students-count': 'Izvještaj broji diplomirane studente kroz zapise dokumenata o završetku studija. Ukoliko ne odaberete godinu promocije ili interval datuma, na izvještaju će biti prikazani svi diplomirani studenti.',
    'students-mobility': 'Izvještaj prikazuje studente koji imaju evidentiranu mobilnost. Apsolventi se prikazuju samo ako imaju evidentiranu mobilnost. Ukoliko ne odaberete nijedan filter, prikazat će se svi studenti sa evidentiranom mobilnošću.',
    'students-disciplinary-procedure': 'Izvještaj prikazuje studente sa evidentiranim disciplinskim postupkom ili mjerom. Prikazani su i studenti koji su se u međuvremenu ispisali sa fakulteta. Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.',
    'students-pause': 'Izvještaj prikazuje studente sa evidentiranim statusom mirovanja. Prikazani su i studenti koji su se u međuvremenu ispisali sa fakulteta. Ovakve studente možete izuzeti iz izvještaja odabirom filtera: isključi ispisane.',
    'enrolled-students-courses': `${enrolledStudentsGroupComment}`,
    'students-not-passed-courses': `${enrolledStudentsGroupComment}`,
    'enrolled-students-passed-courses': `${enrolledStudentsGroupComment}`,
    'enrolled-students-average-grade-passed-courses': `${enrolledStudentsGroupComment}`,
    'passed-course-students-semester': ``,
    'passed-course-students-academic-year': ``,
    'course-pass-rate-semester': ``,
    'course-pass-rate-year': ``,
    'course-students-year': 'Izvještaj prikazuje predmete koji imaju implementaciju u odabranoj akademskoj godini na Vašoj organizacionoj jedinici, sve osnovne studijske programe na kojima se predmet nalazi i profesore angažovane na njegovim implementacijama. Kada postoje grupe, uz svakog profesora prikazuju se studenti iz grupa na kojima je angažovan; na implementacijama bez grupa prikazuju se svi studenti te implementacije. Studenti su odvojeno prikazani prema tome da li predmet upisuju prvi put ili su ga ranije već upisivali. Filter Studijski program služi za izbor predmeta koji pripadaju tom programu; prikaz i dalje obuhvata sve ostale studijske programe na kojima se odabrani predmet nalazi.',
    'study-programs-per-cycle': 'Izvještaj broji aktivne i arhivirane osnovne studijske programe po ciklusu. Ukoliko ne odaberete organizacionu jedinicu, prikazat će se podaci za sve organizacione jedinice.',
    'students-per-cycle': 'Izvještaj prikazuje broj studenata po ciklusu studija. Bez odabrane akademske godine broje se studenti koji imaju barem jedan evidentiran upis u semestar ili apsolventski staž, a nisu diplomirali niti su ispisani sa tog studijskog programa. Svaka osoba broji se samo jednom unutar ciklusa, bez obzira na godinu upisa i broj studijskih programa. Za odabranu akademsku godinu brojanje odgovara izvještaju Upisani studenti za zimski semestar te godine, bez dodatnih filtera za isključivanje studenata: uključuju se upisani studenti, apsolventi i apsolventi ponovci, uključujući one koji su naknadno diplomirali ili se ispisali. U ovom prikazu svaki upis na studijski program broji se jednom, kao zaseban red u izvještaju Upisani studenti.',
    'courses-per-cycle': 'Izvještaj broji predmete po ciklusu na aktivnim studijskim programima. Arhivirani predmeti nisu uključeni. Ukoliko ne odaberete organizacionu jedinicu, prikazat će se podaci za sve organizacione jedinice.',
    'active-study-programs-cycle': 'Izvještaj prikazuje aktivne studijske programe.',
    'teacher-workload': 'Izvještaj prikazuje nastavno opterećenje nastavnika i saradnika.',
    'ou-workload': 'Izvještaj prikazuje nastavno opterećenje organizacione jedinice.',
    'employees-study-program-basic': 'Izvještaj broji zaposlenike i spoljne saradnike po osnovnom studijskom programu.',
    'employees-by-type': 'Izvještaj broji zaposlenike po tipu zaposlenja.',
    'employees-by-academic-title': 'Izvještaj broji zaposlenike po akademskoj tituli.',
    'employees-by-type-gender': 'Obavezno je izabrati tip zaposlenja. Izvještaj broji zaposlenike po spolu.',
    'employees-by-type-position': 'Obavezno je izabrati tip zaposlenja. Izvještaj broji zaposlenike po pozicijama.',
    'employees-average-age-position': 'Obavezno je izabrati tip zaposlenja. Izvještaj računa prosječnu starost zaposlenika po pozicijama.',
    'associate-employees-position': 'Obavezno je izabrati tip osoblja. Izvještaj broji angažovano osoblje po pozicijama.',
    'employees-gender-age-position': 'Obavezno je izabrati tip zaposlenja. Izvještaj prikazuje nastavnike i saradnike po starosti, spolu i poziciji.',
    'employees-gender-age-education-level': 'Obavezno je izabrati tip zaposlenja. Izvještaj prikazuje nenastavno osoblje po kadru, starosti i spolu.',
    'employees-type-academic-year': 'Izvještaj broji zaposlenike u stalnom i dopunskom radnom odnosu po tipu.',
    'analytical-6-2-1': 'Izvještaj prikazuje broj članova akademskog osoblja prema posljednjem važećem akademskom zvanju u odabranoj akademskoj godini. Osoblje se razdvaja na stalno zaposlene i vanjske saradnike, a svaka osoba se broji samo jednom ako joj se period angažmana preklapa s odabranom akademskom godinom.',
    'analytical-6-2-5': 'Izvještaj prikazuje stalno zaposleno akademsko osoblje prema akademskom zvanju, spolu i starosnoj grupi. Za svaku osobu uzima se posljednje važeće zvanje u izvještajnom razdoblju. Starost se za završenu akademsku godinu računa na datum njenog završetka, a za tekuću ili buduću akademsku godinu prema današnjem datumu.',
    'analytical-6-2-4': 'Izvještaj za odabrani studijski program prikazuje ukupan broj studenata, broj stalno zaposlenih i vanjskih nastavnika te izračunate omjere studenata i stalno zaposlenih nastavnika, odnosno stalno zaposlenih i vanjskih nastavnika. Studenti se određuju prema upisu u odabranoj akademskoj godini ili evidentiranom apsolventskom stažu, a nastavnici prema implementacijama predmeta tog studijskog programa.',
    'analytical-6-3-1': 'Izvještaj objedinjuje dolazne i odlazne mobilnosti studenata u odabranoj akademskoj godini. Prikazuju se smjer mobilnosti, semestar, program mobilnosti, student, godina studija, inostrana institucija i država.',
    'analytical-6-1-3': 'Izvještaj prikazuje broj studenata upisanih na odabrani studijski program u odabranoj akademskoj godini, razvrstan prema spolu. Uključeni su prvi upis, ponovci i studenti koji su se naknadno ispisali, ako imaju evidentiran upis u semestar te akademske godine.',
    'analytical-6-1-4': 'Izvještaj prikazuje studente koji su završili odabrani studijski program u odabranoj akademskoj godini. Sadrži ukupan broj završenih studenata, završetak u predviđenom roku ili uz ponavljanje jedne godine, prosječnu dužinu studiranja i prosječnu ocjenu te strukturu prema spolu i domaćem ili stranom državljanstvu.',
    'analytical-6-2-2': 'Izvještaj prikazuje nastavno opterećenje akademskog osoblja na odabranom studijskom programu u akademskoj godini vrednovanja. Za profesore se sabiraju predavanja i vježbe, a za asistente vježbe. Uz zaposlenika se prikazuju status, akademsko zvanje, ukupno opterećenje i njegov udio u ukupnom opterećenju studijskog programa.',
    'analytical-6-2-3': 'Izvještaj prikazuje ukupno opterećenje na odabranom studijskom programu prema tipu nastave i statusu akademskog osoblja. Predavanja, vježbe i njihov zbir odvojeno su prikazani za stalno zaposlene i vanjske saradnike, uz broj kandidata obuhvaćenih mentorskim radom u odabranoj akademskoj godini.'
};

class StudentsReports extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            report: getStoredReport(),
            organizationalUnits: [],
            employeeTypes: [],
            academicYears: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeReport = this.closeReport.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchEmployeeTypes()])
            .then(axios.spread((orgUnitsRes, academicYearsRes, employeeTypesRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet');

                const academicYears = academicYearsRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                })).reverse();

                const employeeTypes = employeeTypesRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                this.setState({
                    employeeTypes, organizationalUnits, academicYears, employeeTypeId: employeeTypesRes.data.find(e => e._key === 'nastavno osoblje').id
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'report') {
            localStorage.setItem('report', value);
        }
    }

    closeReport() {
        this.setState({ report: null });
        localStorage.removeItem('report');
    }

    render() {
        const activeRole = localStorage.getItem('activeRole');
        const studentService = isStudentServiceRole(activeRole);
        const vicedean = isViceDeanForEducationRole(activeRole);
        const unsa = activeRole && activeRole.substr(0, 38) === 'Služba za nastavu i studentska pitanja';
        const quality = activeRole && activeRole.substr(0, 30) === 'Služba za osiguranje kvaliteta';
        const aida = activeRole && activeRole.substr(0, 38) === 'AIDA';
        const admin = activeRole && activeRole.substr(0, 13) === 'Administrator';

        const defaultReportProps = { organizationalUnits: this.state.organizationalUnits, closeReport: this.closeReport };
        const employeeReportProps = {
            ...defaultReportProps,
            employeeTypes: this.state.employeeTypes
        };
        const commonStudentRole = !unsa && !aida && !admin && !quality;
        const reports = [
            {
                id: 'enrolled-students', text: 'Upisani studenti', component: EnrolledStudents, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-average-grade', text: 'Upisani studenti sa prosjekom', component: EnrolledWithAverageGrade, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-per-course', text: 'Upisani studenti po predmetu', component: EnrolledStudentsPerCourses, props: defaultReportProps
            },
            {
                id: 'enrolled-students-countries-count', text: 'Broj upisanih studenata po državljanstvu', component: EnrolledStudentsPerCountries, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-countries-list', text: 'Upisani studenti po državljanstvu', component: EnrolledStudentsPerCountriesAllData, props: defaultReportProps
            },
            {
                id: 'enrolled-students-municipalities-count', text: 'Broj upisanih studenata po općini prebivališta', component: EnrolledStudentsPerMunicipalities, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-municipalities-list', text: 'Upisani studenti po općini prebivališta', component: EnrolledStudentsPerMunicipalitiesAllData, props: defaultReportProps
            },
            {
                id: 'enrolled-students-gender-count', text: 'Broj upisanih studenata po spolu', component: EnrolledStudentsPerGender, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-gender-list', text: 'Upisani studenti po spolu', component: EnrolledStudentsPerGenderAllData, props: defaultReportProps
            },
            (admin || aida || unsa) && {
                id: 'enrolled-students-study-year-study-type', text: 'Broj upisanih studenata po godinama i statusu', component: EnrolledStudentsPerStudyYearAndStudyTypeForFaculty, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-courses', text: 'Upisani studenti sa predmetima koje slušaju', component: EnrolledStudentsWithCourses, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'students-not-passed-courses', text: 'Upisani studenti sa nepoloženim predmetima', component: StudentsWithNotPassedCourses, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-passed-courses', text: 'Upisani studenti po broju položenih predmeta iz prethodne studijske godine', component: EnrolledStudentWithNumberOfPassedCourses, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'enrolled-students-average-grade-passed-courses', text: 'Upisani studenti po prosjeku i broju položenih predmeta iz prethodne studijske godine', component: EnrolledStudentAverageGradeAndPassedCourses, props: defaultReportProps
            },

            commonStudentRole && {
                id: 'previous-semester-students', text: 'Studenti koji nisu upisani u trenutni semestar', component: PreviousSemesterStudents, props: { closeReport: this.closeReport }
            },
            (studentService || vicedean || unsa) && {
                id: 'students-eligible-next-study-year', text: 'Studenti koji ispunjavaju uslov za upis u narednu godinu', component: StudentsEligibleForNextStudyYear, props: defaultReportProps
            },
            {
                id: 'withdrawal-students', text: 'Ispisani studenti', component: WithdrawalStudents, props: defaultReportProps
            },
            {
                id: 'grad-students', text: 'Apsolventi', component: GradStudents, props: defaultReportProps
            },
            (admin || aida || unsa) && {
                id: 'grad-students-study-year-study-type', text: 'Broj apsolvenata po godinama i statusu', component: GradStudentsPerStudyYearAndStudyTypeForFaculty, props: defaultReportProps
            },
            (commonStudentRole || admin || aida) && {
                id: 'locked-graduated-students', text: 'Diplomirani studenti (sa oznakom zaključani/odštampani)', component: LockedGraduatedStudents, props: defaultReportProps
            },
            (admin || aida || unsa || quality) && {
                id: 'graduated-students-count', text: 'Broj diplomiranih studenata (sa oznakom zaključani/odštampani)', component: LockedGraduatedStudents, props: { ...defaultReportProps, countOnly: true }
            },
            (studentService || unsa || vicedean) && {
                id: 'students-mobility', text: 'Studenti na mobilnosti', component: StudentsMobilityReport, props: { closeReport: this.closeReport }
            },
            commonStudentRole && {
                id: 'students-disciplinary-procedure', text: 'Studenti sa disciplinskim mjerama', component: StudentsWithDisciplinaryProcedure, props: defaultReportProps
            },
            commonStudentRole && {
                id: 'students-pause', text: 'Studenti sa statusom mirovanja', component: StudentsWithPause, props: defaultReportProps
            },

            {
                id: 'passed-course-students-semester', text: 'Broj studenata koji su / nisu položili predmet (po semestru)', component: EnrolledAndPassedStudentsPerCourse, props: defaultReportProps
            },
            {
                id: 'passed-course-students-academic-year', text: 'Broj studenata koji su / nisu položili predmet (po akademskoj godini)', component: EnrolledAndPassedStudentsPerCourseByAcademicYear, props: defaultReportProps
            },
            {
                id: 'course-pass-rate-semester', text: 'Prolaznost na predmetima po semestru', component: ConstReports, props: defaultReportProps
            },
            {
                id: 'course-pass-rate-year', text: 'Prolaznost na predmetima po godini', component: ConstReportsByAcademicYear, props: defaultReportProps
            },
            (studentService || vicedean || unsa) && {
                id: 'course-students-year',
                text: 'Pregled nastavnog opterećenja prema broju studenata',
                component: CourseStudentsByAcademicYear,
                props: { ...defaultReportProps, requireOrganizationalUnit: unsa }
            },

            {
                id: 'study-programs-per-cycle', text: 'Broj studijskih programa po ciklusu', component: StudyProgramPerCycle, props: defaultReportProps
            },
            (studentService || vicedean || admin || aida || unsa || quality) && {
                id: 'student-accreditation', text: 'Broj upisanih i diplomiranih studenata po ciklusima i studijskim programima',
                component: StudentAccreditationReport, props: { ...defaultReportProps, academicYears: this.state.academicYears }
            },
            {
                id: 'students-per-cycle', text: 'Broj studenata po ciklusu', component: StudentsByCycle, props: { ...defaultReportProps, academicYears: this.state.academicYears }
            },
            {
                id: 'courses-per-cycle', text: 'Broj predmeta po ciklusu', component: CoursesByCycle, props: defaultReportProps
            },
            {
                id: 'course-list-per-cycle', text: 'Predmeti po ciklusima', component: CourseListPerCycle, props: defaultReportProps
            },
            (admin || aida) && {
                id: 'active-study-programs-cycle', text: 'Aktivni studijski programi po ciklusu', component: StudyProgramsByStudyCyclesForFaculty, props: { ...defaultReportProps, academicYears: this.state.academicYears }
            },

            vicedean && {
                id: 'teacher-workload',
                text: 'Nastavno opterećenje nastavnika/saradnika',
                component: WorkloadReport,
                props: {
                    closeReport: this.closeReport, academicYears: this.state.academicYears, employees: true, employeeTypeId: this.state.employeeTypeId
                }
            },
            quality && {
                id: 'employees-study-program-basic', text: 'Broj zaposlenika i spoljnih saradnika po studijskom programu', component: EmployeesByStudyProgramBasic, props: defaultReportProps
            },
            quality && {
                id: 'employees-by-type', text: 'Broj zaposlenika po tipu zaposlenja', component: EmployeesByType, props: defaultReportProps
            },
            quality && {
                id: 'employees-by-academic-title', text: 'Broj zaposlenika po akademskoj tituli', component: EmployeesByAcademicTytle, props: defaultReportProps
            },
            quality && {
                id: 'employees-by-type-gender', text: 'Broj zaposlenika po spolu (po tipu zaposlenja)', component: EmployeesByTypeAndGender, props: employeeReportProps
            },
            quality && {
                id: 'employees-by-type-position', text: 'Broj zaposlenika po pozicijama (po tipu zaposlenja)', component: EmployeesByTypeAndPosition, props: employeeReportProps
            },
            quality && {
                id: 'employees-average-age-position', text: 'Prosječna starost zaposlenika po pozicijama', component: EmployeesByTypePositionAndAverageYear, props: employeeReportProps
            },
            quality && {
                id: 'associate-employees-position', text: 'Broj angažovanog osoblja po pozicijama', component: AssociateEmployeesByTypeAndPosition, props: employeeReportProps
            },
            quality && {
                id: 'employees-gender-age-position', text: 'Nastavnici i saradnici po starosti i spolu', component: EmployeesGenderAndAgeByPosition, props: employeeReportProps
            },
            quality && {
                id: 'employees-gender-age-education-level', text: 'Nenastavno osoblje po kadru, starosti i spolu', component: EmployeesGenderAndAgeByEducationLevel, props: employeeReportProps
            },
            quality && {
                id: 'employees-type-academic-year', text: 'Broj zaposlenika u stalnom i dopunskom radnom odnosu po tipu i akademskoj godini', component: EmployeesByTypeAndAcademicYear, props: { ...employeeReportProps, academicYears: this.state.academicYears }
            },
            (quality || unsa) && {
                id: 'analytical-students-by-gender', text: 'Struktura studenata prema spolu u izvještajnom razdoblju', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'students-by-gender' }
            },
            (quality || unsa) && {
                id: 'analytical-graduated-students', text: 'Struktura završenih studenata u izvještajnom razdoblju', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'graduated-students' }
            },
            (quality || unsa) && {
                id: 'analytical-academic-staff-by-title-and-status', text: 'Pregled akademskog osoblja prema zvanju i statusu u godini vrednovanja', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'academic-staff-by-title-and-status' }
            },
            (quality || unsa) && {
                id: 'analytical-teaching-load-by-employee', text: 'Nastavno opterećenje stalno zaposlenog akademskog osoblja u akademskoj godini vrednovanja', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'teaching-load-by-employee' }
            },
            (quality || unsa) && {
                id: 'analytical-teaching-load-by-type-and-status', text: 'Pregled opterećenja na studijskim programima po tipu nastave i statusu akademskog osoblja u izvještajnom razdoblju', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'teaching-load-by-type-and-status' }
            },
            (quality || unsa) && {
                id: 'analytical-academic-staff-student-ratio', text: 'Pregled omjera broja akademskog osoblja i studenata na studijskim programima u izvještajnom razdoblju', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'academic-staff-student-ratio' }
            },
            (quality || unsa) && {
                id: 'analytical-academic-staff-by-gender-and-age', text: 'Pregled akademskog stalno zaposlenog osoblja koje izvodi nastavu na studijskim programima prema spolu i godinama starosti u izvještajnom razdoblju', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'academic-staff-by-gender-and-age' }
            },
            (quality || unsa) && {
                id: 'analytical-student-mobility', text: 'Pregled mobilnosti studenata u izvještajnom razdoblju', component: AnalyticalReport, props: { ...defaultReportProps, academicYears: this.state.academicYears, reportCode: 'student-mobility' }
            }
        ].filter(Boolean).map(report => ({
            ...report,
            key: report.id,
            value: report.id
        }));

        const { report } = this.state;
        const activeReport = reports.find(reportOption => reportOption.id === report);
        const ActiveReportComponent = activeReport && activeReport.component;
        let activeReportComment = activeReport && reportComments[activeReport.id];
        if (activeReport && activeReport.id === 'student-accreditation') {
            activeReportComment = 'Izvještaj prikazuje upisane i diplomirane studente po ciklusima i studijskim programima. Broj upisanih prati izvještaj Upisani studenti za zimski semestar odabrane akademske godine, tj. uključeni su apsolventi i apsolventi ponovci evidentirani u toj godini, kao i naknadno diplomirani ili ispisani studenti.' +
                ' Diplomirani se broje prema datumu završetka studija od početka zimskog do kraja ljetnog semestra odabrane akademske godine.'
        }
        if (activeReport && activeReport.id === 'enrolled-students' && !commonStudentRole) {
            activeReportComment = `${enrolledStudentsCountComment} Rezultat je prikazan po organizacionim jedinicama.`;
        }
        if (activeReport && activeReport.id === 'grad-students' && !commonStudentRole) {
            activeReportComment = `${gradStudentsCountComment} Rezultat je prikazan po organizacionim jedinicama.`;
        }
        if (activeReport && isFacultyScopedStudentReportRole(activeRole) && facultyScopedCycleReportComments[activeReport.id]) {
            activeReportComment = facultyScopedCycleReportComments[activeReport.id];
        }
        return (
            <div className="student-reports">
                <Header as="h1">Izvještaji</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"> Spisak izvještaja
                        </Header>
                    </Segment>
                    <Segment style={{ background: '#ffffff' }}>
                        <Header as="h3">
                            <Form noValidate>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite izvještaj"
                                    value={report}
                                    onChange={this.handleInputChange}
                                    name="report"
                                    options={reports}
                                    search
                                    fluid
                                    selection
                                />
                            </Form>
                        </Header>
                    </Segment>

                    {ActiveReportComponent &&
                        <Segment clearing>
                            {activeReportComment &&
                                <Message>
                                    <p>{activeReportComment}</p>
                                </Message>}
                            <ActiveReportComponent key={activeReport.id} {...activeReport.props} />
                        </Segment>}

                </Segment.Group>

            </div>
        );
    }
}

export default StudentsReports;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudentsReports.js